import { TypePartialRackItem } from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/Rack.props";
import {
  ActionActiveRackItem,
  ActionSetActiveRackItem,
  ActionTypesActiveRackItem,
} from "./actionTypes";

interface IStore {
  activeRackItem?: TypePartialRackItem;
}

const initialState: IStore = {};

const reducer = (
  state = initialState,
  action: ActionActiveRackItem
): IStore => {
  switch (action.type) {
    case ActionTypesActiveRackItem.SET_ACTIVE_RACK_ITEM:
      return {
        ...state,
        activeRackItem: (action as ActionSetActiveRackItem).payload,
      };
    default:
      return state;
  }
};
export default reducer;
